import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

function SnapCards() {
  const [archetypes, setArchetypes] = useState([]);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeModal, setActiveModal] = useState(null); // { id, type }
  const [searchTerm, setSearchTerm] = useState(""); // search filter
  const [costFilter, setCostFilter] = useState(null); // cost filter
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [archRes, cardsRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}api/data/snapArchetypes`),
          fetch(`${process.env.REACT_APP_API_URL}api/data/snapAllCards`),
        ]);
        if (!archRes.ok || !cardsRes.ok) throw new Error("Failed to fetch data");
        const [archData, cardData] = await Promise.all([
          archRes.json(),
          cardsRes.json(),
        ]);
        setArchetypes(archData);
        setCards(cardData);
      } catch (err) {
        console.error("Error fetching archetypes/cards:", err);
        setError("Unable to load archetypes.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleModifyCard = async (archetypeId, cardId, action) => {
    const endpoint = action === "add" ? "addCard" : "removeCard";
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}api/snapArchetypes/${archetypeId}/${endpoint}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cardId }),
        }
      );
      if (!res.ok) throw new Error("Failed to update archetype");
      const data = await res.json();
      setArchetypes((prev) =>
        prev.map((a) =>
          a.id === archetypeId ? { ...a, ...data.archetype } : a
        )
      );
    } catch (err) {
      console.error("Error modifying archetype:", err);
      alert("Error updating archetype");
    }
  };

  if (loading)
    return (
      <>
        <br /><br /><br />
        <p style={{ textAlign: "center", color: "#ccc" }}>
          Loading archetypes...
        </p>
      </>
    );

  if (error) 
    return (
      <>
        <br /><br /><br />
        <p style={{ textAlign: "center", color: "red" }}>
          {error}
        </p>
      </>
    );

  return (
    <div className="app-wrapper">
      <h1 className="main-title">Archetypes</h1>
      <br /><br /><br />
      <br /><br /><br />
      <div className="archetype-card-grid">
        {archetypes.map((a) => (
          <div
            key={a.id}
            className="archetype-card"
            onClick={() => navigate(`/archetypes/${a.cardarchetype}`)}
            style={{ cursor: "pointer" }}
          >
            <h2 className="archetype-title">{a.cardarchetype}</h2>
            <div className="preview-fan">
              {a.previewcards?.slice(0, 3).map((c, i) => (
                <img
                  key={c.id}
                  src={c.cardhtml}
                  alt={c.cardname}
                  className={`preview-card card-${i}`}
                />
              ))}
            </div>
            <div
              style={{
                marginTop: "12px",
                display: "flex",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <button
                className="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchTerm("");
                  setCostFilter(null);
                  setActiveModal({ id: a.id, type: "remove" });
                }}
              >
                –
              </button>
              <button
                className="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchTerm("");
                  setCostFilter(null);
                  setActiveModal({ id: a.id, type: "add" });
                }}
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* === Global Modal === */}
      {activeModal && (() => {
        const archetype = archetypes.find((a) => a.id === activeModal.id);
        if (!archetype) return null;

        const archetypeCardIds = archetype.cardids || [];
        const inArchetype = cards.filter((c) => archetypeCardIds.includes(c.id));
        const notInArchetype = cards.filter((c) => !archetypeCardIds.includes(c.id));

        let filteredCards = activeModal.type === "remove" ? inArchetype : notInArchetype;

        // Apply search
        filteredCards = filteredCards.filter((item) =>
          item.cardname.toLowerCase().includes(searchTerm.toLowerCase())
        );

        // Apply cost filter
        if (costFilter !== null) {
          if (costFilter === "0-1") {
            filteredCards = filteredCards.filter((item) => item.cardcost <= 1);
          } else if (costFilter === "6+") {
            filteredCards = filteredCards.filter((item) => item.cardcost >= 6);
          } else {
            filteredCards = filteredCards.filter(
              (item) => item.cardcost === costFilter
            );
          }
        }

        return (
          <div className="modal-overlay" onClick={() => setActiveModal(null)}>
            <div
              className="modal-content"
              style={{
                maxWidth: "900px",
                maxHeight: "80vh",
                overflowY: "auto",
                background: "#111",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h2 style={{ textAlign: "center", color: "rgb(197,176,55)" }}>
                {activeModal.type === "add" ? "Add Cards" : "Remove Cards"} –{" "}
                {archetype.cardarchetype}
              </h2>

              {/* Search bar */}
              <div style={{ textAlign: "center", margin: "12px 0" }}>
                <input
                  type="text"
                  placeholder="Search cards..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    padding: "8px 12px",
                    width: "60%",
                    borderRadius: "6px",
                    border: "1px solid rgba(255,255,255,0.2)",
                    background: "#222",
                    color: "#fff",
                  }}
                />
              </div>

              {/* Cost filter buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "8px",
                  marginBottom: "12px",
                }}
              >
                {["0-1", 2, 3, 4, 5, "6+"].map((val) => (
                  <button
                    key={val}
                    className="button"
                    style={{
                      background:
                        costFilter === val ? "rgb(197,176,55)" : "#222",
                      color: costFilter === val ? "#000" : "#fff",
                      padding: "6px 12px",
                      fontSize: "0.9rem",
                    }}
                    onClick={() =>
                      setCostFilter(costFilter === val ? null : val)
                    }
                  >
                    {val}
                  </button>
                ))}
              </div>

              <div
                className="card-grid"
                style={{
                  gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                }}
              >
                {filteredCards.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      background: "rgba(255,255,255,0.03)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      borderRadius: "10px",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={item.cardhtml}
                      alt={item.cardname}
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        marginBottom: "8px",
                      }}
                    />
                    <button
                      className="button"
                      style={{
                        fontSize: "0.85rem",
                        padding: "4px 10px",
                        marginTop: "4px",
                      }}
                      onClick={() =>
                        handleModifyCard(
                          archetype.id,
                          item.id,
                          activeModal.type
                        )
                      }
                    >
                      {activeModal.type === "add" ? "Add" : "Remove"}
                    </button>
                  </div>
                ))}
              </div>

              <div style={{ textAlign: "center", marginTop: "16px" }}>
                <button className="button" onClick={() => setActiveModal(null)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

export default SnapCards;
